<template>
    <img src="@/assets/notification-bell.png" stroke="#743bcd" fill="currentColor"  class="p-1 bg-[#F5DFFF] rounded-full" width="26" height="26" alt="Toogle Theme" />
</template>

<script>
export default {
    name: "TooglePushNotification"
};
</script>